export const REFERRAL_ROUTE_PATH = '/r/:slug';

/** Merge referral UTMs while keeping navigation within the current Funnel. */
export default function referralDestination(destination, slug, search = '') {
  const { origin } = window.location;
  const url = new URL(destination || '/', `${origin}/`);
  if (url.origin !== origin || /^\/r(?:\/|$)/i.test(url.pathname)) {
    throw new Error('Invalid referral destination');
  }
  const incoming = new URLSearchParams(search);
  const defaults = { utm_source: 'partner', utm_medium: 'referral', utm_campaign: slug };
  Object.entries(defaults).forEach(([key, value]) => {
    url.searchParams.set(key, incoming.get(key) ?? url.searchParams.get(key) ?? value);
  });
  return `${url.pathname}${url.search}${url.hash}`;
}
